import 'regenerator-runtime/runtime';
import { call, select, takeEvery } from 'redux-saga/effects';
import {
  DoRequestResponse,
  GlobalActions,
  ShopTarifierungRequestEvents,
  TarifiereAngebotForShopAction,
} from '@ps20-frontend/shop-integration-redux';
import { ShopTarifierer, ShopTarifierungsErgebnisHandler } from '@ps20-frontend/preis-lib';
import { App } from '@ps20-frontend/frontend-models';
import { TaasRequestModel, TaasResponseModel, TaasTkvV1Data } from '@ps20/bff-models';
import { CallEffect, ForkEffect, SelectEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { buildTaasTkvV1DataForShop } from './transformer/tkvData.transformer';
import { getVersichertesRisiko } from './inDashboardUebernehmenSaga';

export const shopTarifierungsErgebnisHandler = new ShopTarifierungsErgebnisHandler<
  IAppState,
  TaasTkvV1Data
>(App.TKV, getVersichertesRisiko);
export const shopTarifierer = new ShopTarifierer({
  appId: App.TKV,
  taasDataBuilder: buildTaasTkvV1DataForShop,
  resultHandler: shopTarifierungsErgebnisHandler,
});

export function* shopTarifierungTkv(): Generator<ForkEffect> {
  yield takeEvery(
    ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_TKV,
    safeSaga(callSuccessOnMatchingAngebotsId, App.TKV),
  );
  yield takeEvery(
    GlobalActions.TARIFIERE_ANGEBOT_FOR_SHOP,
    safeSaga(callTarifierungOnMatchingAngebotsId, App.TKV),
  );
}

export function* callTarifierungOnMatchingAngebotsId(
  tarifiereAngebotAction: TarifiereAngebotForShopAction,
): Generator<SelectEffect | CallEffect> {
  const appState: IAppState = (yield select()) as IAppState;
  const angebotsIdIsMatching = appState.angebotsId === tarifiereAngebotAction.payload.angebotsId;

  if (angebotsIdIsMatching) {
    yield call(shopTarifierer.callTarifierung, tarifiereAngebotAction);
  }
}

export function* callSuccessOnMatchingAngebotsId(
  successAction: DoRequestResponse<TaasResponseModel, TaasRequestModel<TaasTkvV1Data>>,
): Generator<SelectEffect | CallEffect> {
  const appState: IAppState = (yield select()) as IAppState;
  const originEvent: TarifiereAngebotForShopAction =
    successAction.doRequestAction.payload.originEvent;
  const angebotsIdIsMatching = appState.angebotsId === originEvent.payload.angebotsId;

  if (angebotsIdIsMatching) {
    yield call(shopTarifierer.handleSuccess, successAction);
  }
}
